import { useState } from "react";
import { useDispatch } from "react-redux";
import loginSchema from "../../validation/loginSchema";
import { encryptData } from "../../utils/encryptDecrypt";
import { authActions } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../components/common/ui/Loader";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { TextInput, PasswordInput } from "../../components/common/ui/Inputs";
import Logo from "../../assets/Broward-Partnerships-for-kids-logo.png";
import { useNavigate } from "react-router-dom";
import { history } from "../../_helpers";

function AdminLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e?.target;

    if (name === "email") {
      // const regex = /^[a-zA-Z0-9.@_\s]*$/;
      const regex = /^[a-zA-Z0-9.@!#$*+-_\s]*$/;
      if (!regex.test(value)) return;
      if (value.trim() === "" && value !== "") return;
    }
    setLoginForm({ ...loginForm, [name]: value.trim() });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = (e) => {
    debugger;
    e?.preventDefault();
    Swal.close();
    setSubmit(true);
    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = loginSchema(loginForm);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [e?.path.toString()]: e?.message,
        }));
        document
          .querySelector(`input[name=${path}]`)
          ?.classList?.add("input-error");
      });
      return;
    }
    // showToastNotification("info", "Button clicked");
    // const encryptPassword = encryptData(loginForm?.UserPassword);
    const encryptPassword = encryptData(loginForm?.password);
    const safeEncrypted = encodeURIComponent(encryptPassword);
    dispatch(
      authActions.login({
        email: loginForm?.email,
        // password: loginForm?.password,
        password: safeEncrypted,
        isAdminPanel: true,
      })
    )
      .then((result) => {
        debugger;
        setSubmit(false);
        console.log(result?.payload);
        if (result?.payload?.status === 1) {
          history?.navigate("/Admin/Dashboard");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setSubmit(false);
      });
  };

  if (loader) {
    return <CustomLoader />;
  }
  return (
    <>
      <section className="sign-in-section admin-login-banner">
        <span className="sr-only" role="img" aria-label="Admin Login Page"></span>
        <div className="container">
          <div className="row justify-content-center align-items-center authentication authentication-basic min-height-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12">
              <div className="admin-login-container custom-card my-4">
                <div className="card-body p-5">
                  <div className="mb-3 d-flex justify-content-center cursor-pointer" onClick={() => {
                    history?.navigate("/Home");
                  }}>
                    <img
                      className="Sidebarlogo"
                      src={Logo}
                      alt="small-logo"
                    ></img>
                  </div>

                  <form
                    onSubmit={(e) => {
                      handleLogin(e);
                    }}
                  >
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">
                        Email<span className="text-danger">*</span>
                      </label>

                      <TextInput
                        name="email"
                        id="email"
                        ariaLabel="Email Address"
                        placeholder="Email Address"
                        required={true}
                        handleChange={(e) => {
                          handleChange(e);
                        }}
                        // value={userLoginForm?.email}
                        errorMessage={errorMessage}
                      />
                    </div>
                    <div className="mb-4">
                      <label htmlFor="password" className="form-label">
                        Password<span className="text-danger">*</span>
                      </label>
                      <PasswordInput
                        name="password"
                        ariaLabel="Password"
                        id="password"
                        placeholder="Password"
                        required={true}
                        handleChange={(e) => {
                          handleChange(e);
                        }}
                        // value={userLoginForm?.password}
                        showPassword={showPassword}
                        togglePasswordVisibility={togglePasswordVisibility}
                        maxlength={25}
                        errorMessage={errorMessage}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div className="form-check"></div>
                      <Link
                        to="/Admin/forgotpassword"
                        className="text-primary text-decoration-none"
                      >
                        Forgot Password
                      </Link>
                    </div>
                    <div className="div-center">
                      <button
                        type="submit"
                        className="sign-in-button"
                      // disabled={isLoading}
                      >
                        Login
                        {!submit ? (
                          <i className="css-arrow-icon bi bi-arrow-right"></i>
                        ) : (
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminLogin;
